
import React from 'react'
export default function Feedback() {
  return <iframe
    title='feeback'
    src="https://docs.google.com/forms/d/e/1FAIpQLScrzsanSxfg_knuToecp021280Yd5EEXG0vLs9g072TyN15fg/viewform?embedded=true"
    width={window.innerWidth}
    height={window.innerHeight - 67}
    frameBorder="0"
    marginHeight="0"
    marginWidth="0">
      Loading...
    </iframe>
}